import { AiOutlinePlusCircle, AiOutlineMinusCircle } from "react-icons/ai";
import axios from "axios";
import { useEffect, useState } from "react";
import Navbar from "../../components/navbar/Navbar";
import "./product.css";
import { useLocation } from "react-router-dom";
// import { RadioGroup } from "@headlessui/react";
import { useDispatch } from "react-redux";
import { addProduct } from "../../redux/cartSlice";

const Product = () => {
  let location = useLocation();
  const id = location.pathname.split("/")[2];

  const dispatch = useDispatch();

  const [product, setProduct] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedSize, setSelectedSize] = useState("");

  useEffect(() => {
    const getProducts = async () => {
      try {
        // eslint-disable-next-line no-unused-vars
        const result = await axios
          .get(process.env.REACT_APP_API_URL + "/product/" + id)
          .then((res) => {
            setProduct(res.data.product);
          });
      } catch (error) {
        console.log(error);
      }
    };
    getProducts();
  }, [id]);

  const [quantity, setQuantity] = useState(1);

  const handleQuantity = (type) => {
    if (type === "minus") {
      return setQuantity(quantity > 1 ? quantity - 1 : 1);
    } else {
      return setQuantity(quantity + 1);
    }
  };

  const handleClick = () => {
    dispatch(addProduct({ ...product, quantity, selectedColor: selectedColor, selectedSize: selectedSize }));
  };

  return (
    <>
      <Navbar />
      <div className="product block md:flex px-2 lg:px-20 py-4 gap-4 mt-16">
        <div className="left flex-initial w-full md:w-3/5">
          <img
            className="w-full object-cover rounded drop-shadow"
            src={product?.image}
            alt={product?.title}
          />
        </div>
        <div className="right flex-1">
          <h1 className="title mt-2 lg:mt-0 text-lg text-gray-700 font-Roboto font-semibold pb-2 border-b-gray-500">
            {product?.title}
          </h1>

          <p className="description text-sm md:text-base text-gray-700 font-Poppins font-medium mb-1">
            Description
          </p>
          <p className="description text-base text-gray-500 font-Poppins font-normal mb-2 ">
            {product?.desc}
          </p>

            <div className="colorAndSizeRow flex mt-4 gap-4 justify-center lg:justify-start">
              {/* Colors */}
              {product?.color && (
                <div className="color items-center flex justify-center gap-2">
                  <h2 className="text-base text-gray-600 font-Roboto font-medium mb-1">
                    Color:
                  </h2>
                  <select
                    name="color"
                    onChange={(e) => setSelectedColor(e.target.value)}
                    className="p-2 text-gray-500 text-sm font-Roboto text-start bg-white border border-gray-500 rounded"
                  >
                    {product?.color?.map((c, index) => (
                      <option key={c + index} value={c}>{c}</option>
                    ))}
                  </select>
                </div>
              )}
              {/* Size */}
              {product?.size && (
                <div className="size items-center flex  justify-center gap-2">
                  <h2 className="text-base text-gray-600 font-Roboto font-medium mb-1">
                    Size:
                  </h2>
                  <select
                    onChange={(e) => setSelectedSize(e.target.value)}
                    name="size"
                    className="p-2 text-gray-500 text-sm font-Roboto text-start bg-white border border-gray-500 rounded"
                  >
                    {product?.size?.map((s, index) => (
                      <option key={s + index} value={s}>{s}</option>
                    ))}
                  </select>
                </div>
              )}
            </div>
            <div className="quantityAndPriceRow mt-6 flex justify-between items-center">
                <div className="quantity flex items-center justify-start gap-2">
                  <h3 className="text-sm text-gray-900 font-medium">
                    Quantity:
                  </h3>
                <div className="quantity btn flex gap-1">
                    <AiOutlineMinusCircle size="1.5em"
                      className="drop-shadow cursor-pointer fill-gray-600 hover:fill-gray-500 transition"
                      onClick={() => handleQuantity("minus")}
                    />
                  <h1 className="px-1 text-xl text-gray-700 drop-shadow font-Roboto font-medium">
                    {quantity}
                  </h1>
                    <AiOutlinePlusCircle size="1.5em"
                      className="drop-shadow cursor-pointer fill-gray-600 hover:fill-gray-500 transition"
                      onClick={() => handleQuantity("plus")}
                    />
                    </div>
                </div>

              <h3 className="price text-lg text-gray-800 font-Roboto font-medium">${product?.price}</h3>
            </div>

            <button
              onClick={(e) => handleClick(e.preventDefault())}
              type="submit"
              className="mt-10 w-full bg-primary rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-gray-700 hover:bg-primary-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
            >
              Add to bag
            </button>

        </div>
      </div>
    </>
  );
};

export default Product;
